import { useEffect, useState } from 'react';
import { useConfiguration } from '@ocx/data-configuration';
import { GEOLOCATION_CHANGED_EVENT, geolocationStore } from './geolocationStore';

interface UseGeolocationOptions {
  watch?: boolean;
}

export const useGeolocation = (options: UseGeolocationOptions = {}) => {
  const watchTimeout = useConfiguration('storeLocator.watchTimeout');
  // TODO: useSyncExternalStore can be used as an alternative to useState
  // This hook can be extended to display a warning pop-up when geolocation is
  // unavailable and allow the user to access the app settings.

  const [state, setState] = useState(() => geolocationStore.state);

  useEffect(() => {
    const update = () => {
      setState(geolocationStore.state);
    };

    geolocationStore.addEventListener(GEOLOCATION_CHANGED_EVENT, update);
    geolocationStore.refresh(); // refresh state each time when hook is mounted

    if (options.watch) {
      geolocationStore.startPolling(watchTimeout);
    }

    return () => {
      geolocationStore.removeEventListener(GEOLOCATION_CHANGED_EVENT, update);
      if (options.watch) {
        geolocationStore.endPolling();
      }
    };
  }, [options.watch, watchTimeout]);

  return { ...state, refresh: geolocationStore.refresh };
};
